import React from 'react'
import CircleIconWithNotification from 'components/base-ui/CircleIconWithNotification'
import { privateCartSelector } from 'store/slices/privateCartSlice'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { SubPageName } from 'enums/buffet'

type CartIconProps = {
  testId?: string
}

const CartIcon = ({ testId }: CartIconProps) => {
  const privateCart = useSelector(privateCartSelector)
  const history = useHistory()

  return (
    <CircleIconWithNotification
      testId={testId}
      iconName="basket-3"
      notifyNumber={privateCart.totalQuantity}
      onCLickIcon={() => history.push(SubPageName.PrivateCart)}
    />
  )
}

export default CartIcon
